import {
  fetchClient
} from "./chunk-64N4INLD.mjs";
import {
  resolveCaptcha
} from "./chunk-UELQYFJ7.mjs";
import {
  __async,
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/core/wbk/nafath/send.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var requestNafath = (_0) => __async(null, [_0], function* ({ id, locale }) {
  try {
    const lang = getLocaleOnly(locale);
    const captcha = yield resolveCaptcha("nafath");
    const data = yield fetchClient({
      url: "/nafath/send-request",
      options: {
        method: "POST",
        body: JSON.stringify(__spreadValues({ id, lang }, captcha))
      }
    });
    return data;
  } catch (error) {
    throw new Exception({
      error,
      name: "requestNafathException",
      context: { extra: { id } }
    });
  }
});

export {
  requestNafath
};
//# sourceMappingURL=chunk-2THTUX6I.mjs.map